import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";

export function MessagesButton({ testid = "dashboard-messages-link" }) {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    const load = () => api.get("/messages/unread-count").then((r) => setUnread(r.data.count || 0)).catch(() => {});
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, []);
  return (
    <Link to="/messages">
      <Button variant="outline" className="rounded-sm" data-testid={testid}>
        <MessageSquare className="w-4 h-4 mr-1.5" />Messages
        {unread > 0 && (
          <span className="ml-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-white text-[10px] font-bold inline-flex items-center justify-center" data-testid="dashboard-messages-badge">{unread}</span>
        )}
      </Button>
    </Link>
  );
}
